import { StringConstantsMixin } from 'react_components/mixins/shared/string_constants_mixin';
import { AuthenticationType } from '@alltrails/analytics/amplitudeEnums';
import { ServerCommunicationUtil } from './server_communication_util';
import { authSuccessCallback } from './AuthHandlers';

// Note: These handlers are used for both new registrations (signups) AND logins

const facebookHandler = (
  response: { accessToken: any; userID: any; expiresIn: any },
  locale: string,
  successCallback: Function = () => {},
  errorCallback = () => {},
  completeCallback = () => {},
  referralLink?: string
) => {
  if (!response.accessToken) {
    return;
  }

  const fbData = {
    facebook_id: response.userID,
    facebook_token: response.accessToken,
    facebook_expires: response.expiresIn,
    create_session: true,
    ...(referralLink && { referral_code: referralLink })
  };
  const headers = locale ? { 'X-Language-Locale': locale } : {};

  ServerCommunicationUtil.postApiEndpoint(
    '/api/alltrails/facebook/login',
    fbData,
    (data: any) => {
      authSuccessCallback(data, AuthenticationType.Facebook);
      successCallback(data);
    },
    errorCallback,
    completeCallback,
    headers
  );
};

// Note: This handler works differently than the others, where the user is redirected to
// an Apple login page and then redirected back to AllTrails.
// Because of this, there is a tracking callback implemented in GlobalActions
// that tracks that the signup/login redirect was successful.
const appleHandler = (referralLink?: string) => {
  let redirectURI = `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}${
    StringConstantsMixin.constants.APPLE_SIWA.REDIRECT_PATH
  }`;

  if (referralLink) {
    const params = new URLSearchParams();
    params.set('referral_code', referralLink);
    redirectURI += `?${params.toString()}`;
  }

  const authUrl = `${
    StringConstantsMixin.constants.APPLE_SIWA.AUTHORIZE_URL + StringConstantsMixin.constants.APPLE_SIWA.AUTHORIZE_PARAMS
  }&client_id=${StringConstantsMixin.constants.APPLE_SIWA.CLIENT_ID}&redirect_uri=${encodeURIComponent(redirectURI)}&scope=${encodeURIComponent(
    StringConstantsMixin.constants.APPLE_SIWA.SCOPES
  )}`;

  window.location.href = authUrl;
};

const appleRedirectHandler = () => {
  const params = new URLSearchParams(window.location.search);
  const appleOAuth = params.get('apple_oauth');
  if (appleOAuth) {
    const is_sign_up = appleOAuth === 'signup';
    authSuccessCallback({ is_sign_up }, AuthenticationType.Apple);
    const search = params.toString();
    window.history.replaceState(null, null, window.location.pathname + (search !== '' ? `?${search}` : ''));
  }
};

const googleHandler = (
  googleUser: { getAuthResponse: () => { id_token: any } },
  locale: string,
  successCallback: Function = () => {},
  errorCallback = () => {},
  completeCallback = () => {},
  referralLink?: string,
  oneTap?: boolean
) => {
  const token = googleUser.getAuthResponse().id_token;
  const data = {
    google_token: token,
    create_session: true,
    ...(referralLink && { referral_code: referralLink }),
    ...(oneTap && { one_tap: oneTap })
  };
  const headers = locale ? { 'X-Language-Locale': locale } : {};
  ServerCommunicationUtil.postApiEndpoint(
    '/api/alltrails/google/login',
    data,
    (data: any) => {
      authSuccessCallback(data, oneTap ? AuthenticationType.GoogleOneTap : AuthenticationType.Google);
      successCallback(data);
    },
    errorCallback,
    completeCallback,
    headers
  );
};

export { facebookHandler, appleHandler, appleRedirectHandler, googleHandler };
